var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-kgl-cta",on:{"click":_vm.openKGLClicked}},[_c('round-add-button',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("לפתיחת קופת גמל להשקעה ב-5 דק׳!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }